import gql from 'graphql-tag';

export const listTransactionsQuery = gql`
  query listTransactions($listTransactionsRequest: ListTransactionsRequest!) {
    accounts {
      listTransactions(listTransactionsRequest: $listTransactionsRequest) {
        transactions {
          transactionId
          paidBy
          productName
          paymentType
          amount
          currency
          createdAt
          updatedAt
          status
          taxAmount
        }
        pageInfo {
          perPage
          start
          total
        }
      }
    }
  }
`;
